import { vuexPto } from '@/store/compositionV2/module/pto'
import { PTOWorkSignApi } from '@/api/pto/project/estimate'
import { getYesOrNo } from '@/utils/string/getYesOrNo'
import { priceFormat } from '@/utils/form/priceFormat'

const state = () => ({
  ...vuexPto.createState(),
  api: PTOWorkSignApi,
  namePageDetailed: 'PtoProjectWorkSignUpdate',
  tableHeaders: [
    {
      title: 'План, объем',
      isSortable: true,
      sortName: 'plan_volume'
    },
    {
      title: 'План, руб.',
      isSortable: true,
      sortName: 'plan'
    },
    {
      title: 'Подписано, объем',
      isSortable: true,
      sortName: 'sign_volume'
    },
    {
      title: 'Подписано, руб. (в ценах 2001)',
      isSortable: true,
      sortName: 'sign_2001'
    },
    {
      title: 'Подписано, руб. (в тек. ценах без НДС)',
      isSortable: true,
      sortName: 'sign_without_nds'
    },
    {
      title: 'Подписано, руб. (в тек. ценах с НДС)',
      isSortable: true,
      sortName: 'sign_with_nds'
    },
    {
      title: 'Дата начала',
      isSortable: true,
      sortName: 'start_date'
    },
    {
      title: 'Дата окончания',
      isSortable: true,
      sortName: 'finish_date'
    },
    {
      title: '№ КС-2',
      isSortable: true,
      sortName: 'number_ks'
    },
    {
      title: 'Собственное производство',
      isSortable: true,
      sortName: 'is_own_production'
    },
    {
      title: 'Трудозатраты',
      isSortable: true,
      sortName: 'labor_costs'
    },
    {
      title: 'ФОТ',
      isSortable: true,
      sortName: 'fot'
    },
    {
      title: '№ сч-ф',
      isSortable: true,
      sortName: 'account_number'
    }
  ]
})

const getters = {
  ...vuexPto.createGetters(),
  getList: state => {
    return state.list.map(item => {
      return {
        isControlsActive: item.isControlsActive,
        isActive: item.isActive,
        id: item.id,
        values: [
          item.plan_volume || '-',
          priceFormat(item.plan) || '-',
          item.sign_volume || '-',
          priceFormat(item.sign_2001) || '-',
          priceFormat(item.sign_without_nds) || '-',
          priceFormat(item.sign_with_nds) || '-',
          item.start_date || '-',
          item.finish_date || '-',
          item.number_ks || '-',
          getYesOrNo(item.is_own_production),
          item.labor_costs || '-',
          item.fot || '-',
          item.account_number || '-'
        ]
      }
    })
  }
}

const mutations = {
  ...vuexPto.createMutations()
}

const actions = {
  ...vuexPto.createActions()
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
